import React from 'react';
import WarningIcon from '@material-ui/icons/Warning';
import { makeStyles, Typography } from '@material-ui/core';
import { HorizontalGrid } from '@components/HorizontalGrid';

export type WarningMessageProps = {
    message: string
}

export function WarningMessage ({ message }: WarningMessageProps) {
    const cls = useStyles();

    return (
        <HorizontalGrid className={cls.root}>
            <WarningIcon className={cls.icon} />
            <Typography>{ message }</Typography>
        </HorizontalGrid> 
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(2)
    },

    icon: {
        color: 'orange',
        marginRight: theme.spacing(1),
    }
}));